/* istanbul ignore file */
export default {
  officeLocation: {
    type: 'string',
    required: true,
  },
  vendorId: {
    type: 'string',
    required: true,
  },
  requiredDeliveryDate: {
    type: 'date',
    required: false,
  },
  purchaseDescription: {
    type: 'string',
    required: true,
    maxSize: 2000,
  },
  purchasePurpose: {
    type: 'string',
    required: true,
    maxSize: 1000,
  },
  isPaymentConfirmNeeded: {
    type: 'enum',
    required: true,
  },
  purchaseInvoice: {
    type: 'array',
    maxSize: 1,
  },
};
